import * as React from "react";
import { useEffect, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { DataGrid } from "@mui/x-data-grid";
import { Modal, Switch, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { breadcrumbsActions } from "@store/breadcrumbs";
import { setLoading } from "@store/asset-loader";
import ApplicationPageTemplate from "../../../dashboard/components/ApplicationPageTemplate/ApplicationPageTemplate";
import { CountryList } from "../../../../components/CountryList";
import AddRecommendationModal from "./addRecommendation";
import styled from "styled-components";
import { getAllRecommendation, deleteRecommendation, addRecommendation, updateRecommendation } from "@store/recommendation-management";
import DashboardEnvContext from "../../../../DashboardApp/DashboardEnvContext";
import TagComponent from "@components/Tag";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		overflow: "scroll",
	},
	modalContent: {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		backgroundColor: "#fff",
		padding: 16,
		width: "50%",
		overflow: "scroll",
	},
	modalTitle: {
		marginBottom: 10,
	},
	formLabel: {
		display: "in-line",
		marginBottom: 5,
		fontWeight: "bold",
	},
	formInput: {
		width: "100%",
		marginBottom: 10,
		padding: 8,
		border: "1px solid #ccc",
		borderRadius: 4,
		boxSizing: "border-box",
	},
	formCheckbox: {
		marginRight: 8,
	},
	formActions: {
		display: "flex",
		justifyContent: "flex-end",
		marginTop: 10,
	},
}));

const FilterActionContainer = styled.div`
	padding: 16px 16px 0 16px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
`;

const FilterContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

const OptionContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

const TitleCell = styled.div`
	min-width: 100%;
	flex: 1;
	font-weight: 500;
`;

const ActionButtons = styled.div`
	flex-direction: column;
	flex-wrap: nowrap;
	align-items: flex-start;
	padding: 8px 0;
	gap: 10px;
`;

const TableProductLabels = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	align-items: flex-start;
	padding: 8px 0;
`;

const Recommendation = () => {
	const dispatch = useDispatch();
	const dashboard = useContext(DashboardEnvContext);
	const navigate = useNavigate();
	const classes = useStyles();
	const recommendationList = useSelector((state) => state.recommendationList.recommendationList);
	const labels = useSelector((state) => state.recommendationList.labels);
	const [rowsDataGrid, setRowsDataGrid] = useState([]);
	const [modalOpen, setModalOpen] = useState(false);
	const [selectedImageUrl, setSelectedImageUrl] = useState("");
	const [defaultCountry, setDefaultCountry] = useState("my");
	const [openModal, setOpenModal] = useState(false);
	// const [openModalUpdate, setOpenModalUpdate] = useState(false);
	const [existingFormData, setExistingFormData] = useState(null);
	const showDeleted = false;

	const handleCloseModal = () => {
		setSelectedImageUrl("");
		setModalOpen(false);
	};

	useEffect(() => {
		dispatch(
			breadcrumbsActions.setBreadcrumbs([
				{ label: "Home", url: "/" },
				{ label: "Recommendation Management", url: "/recommendation-management" },
			]),
		);
		dispatch(getAllRecommendation({ countryCode: defaultCountry }));
	}, [dispatch, showDeleted]);

	useEffect(() => {
		if (recommendationList) {
			setRowsDataGrid([...recommendationList]);
		}
	}, [recommendationList]);

	//onchange filter by recommendation title
	const columns = [
		{
			field: "title",
			headerName: "Title",
			width: 300,
			renderCell: (params) => (
				<div>
					<TitleCell>{params.value}</TitleCell>
				</div>
			),
		},
		{
			field: "label",
			headerName: "Label",
			width: 220,
			renderCell: (params) => (
				<TableProductLabels>
					{
						params.value && 
						params.value.length > 0 && 
						params.value.map((label) => <TagComponent key={label.id} containerMargin="0px" tag={label} showDeleteIcon={false} />)
					}
				</TableProductLabels>
			),

		},
		{ field: "country", headerName: "Country", width: 80 },
		{
			field: "isDeleted",
			headerAlign: "center",
			headerName: "Active/Inactive",
			width: 150,
			renderCell: (params) => <Switch checked={!params.value} onChange={(event) => handleIsDeletedChange(params.row, event.target.checked)} key={params.id} />,
		},
		{
			field: "actions",
			headerAlign: "center",
			headerName: "Actions",
			width: 250,
			renderCell: (params) => (
				<ActionButtons>
					<>
					{
						<Button
							variant="outlined"
							color="primary"
							size="small"
							style={{marginRight:"10px"}}
							startIcon={<ModeEditIcon size="small" />}
							onClick={() => {
								navigate(`/recommendation-management/list?countryCode=${defaultCountry}`);
							}}
						>
							Add Products
						</Button>
					} 
					{
						 <Button
							variant="outlined"
							color="primary"
							size="small"
							onClick={() => {
								const updatedRowData = { ...params.row };
								setExistingFormData(updatedRowData);
								setOpenModal(true);
							}}
						>
							Update
						</Button>
					}
					</>
				</ActionButtons>
			),
		},
	];

	// Add / Update modal
	const handleOpenModaladd = () => {
		setOpenModal(true);
	};

	// handle close modal
	const handleCloseModaladd = () => {
		setExistingFormData(null);
		setOpenModal(false);
	};

	const handlSelectChange = (country) => {
		if (!country) return;
		setDefaultCountry(country);
		dispatch(getAllRecommendation({ countryCode: country }));
	};

	const inputProps = {
		required: true,
		fullWidth: true,
		width: "250px",
		margin: "normal",
		onChange: handlSelectChange,
	};
	const formatSubErrors = (subErrors) => `Error while trying to add a new Product:\n\n${subErrors.map((item) => `${item.field}: ${item.message}`).join("\n\n")}`;

	const handleSubmit = (data) => {
		dispatch(setLoading(true));
		if (!!data.id) {
			dispatch(updateRecommendation({ ...data }))
				.then((response) => {
					dispatch(setLoading(false));
					if (response.payload.status === "Ok") {
						return dashboard.utils.showSuccessNotification("Recommendation updated successfully");
					} else {
						if (!!response.payload.subErrors) {
							return dashboard.utils.showErrorNotification(formatSubErrors(response.payload.subErrors));
						} else if (!!response.payload.message && response.payload.message !== "") {
							return dashboard.utils.showErrorNotification(`Error update recommendation: ${response.payload.message}`);
						} else {
							return dashboard.utils.showErrorNotification("Error update recommendation");
						}
					}
				})
				.catch(function (error) {
					console.error("update recommendation error:", error)
					dispatch(setLoading(false));
					dashboard.utils.showErrorNotification(`Failed to update recommendation: ${error}`);
				});
		} else {
			dispatch(addRecommendation({ ...data }))
				.then((response) => {
					dispatch(setLoading(false));
					if (response.payload.status === "CREATED") {
						return dashboard.utils.showSuccessNotification("Recommendation added successfully");
					} else {
						let errorSummary = "";
						if (!!response.payload.subErrors) {
							errorSummary = formatSubErrors(response.payload.subErrors);
							return dashboard.utils.showErrorNotification(errorSummary);
						} else if (!!response.payload.message && response.payload.message !== "") {
							return dashboard.utils.showErrorNotification(`Error create new recommendation: ${response.payload.message}`);
						} else {
							return dashboard.utils.showErrorNotification("Error creating new recommendation");
						}
					}
				})
				.catch((error) => {
					console.error("add recommendation error:", error)
					dispatch(setLoading(false));
					dashboard.utils.showErrorNotification(`Failed to add new recommendation: ${error}`);
				});
		}
	};

	const handleIsDeletedChange = (data, checked) => {
		dispatch(setLoading(true));

		dispatch(deleteRecommendation({ receommendationId: data.id }))
			.then(() => {
				dispatch(setLoading(false));
				return dashboard.utils.showSuccessNotification("Recommendation updated successfully");
			})
			.catch(function (error) {
				console.error(error);
				dashboard.utils.showErrorNotification(`Failed to update Recommendation: ${error}`);
			});
	};

	return (
		<ApplicationPageTemplate title={"Recommendation Configs"} description={"Manage Recommendation with Add & Update"} pageReady={true}>
			<div style={{ height: 800, width: "100%" }}>
				<FilterActionContainer>
					<FilterContainer>
						<CountryList {...inputProps} onChange={handlSelectChange} placeholder="Select Country" id="country" value={defaultCountry != null ? defaultCountry : "my"} background="white" compactView />
						<OptionContainer></OptionContainer>
					</FilterContainer>
					<div>
						<Button 
							variant="contained" 
							color="primary" 
							onClick={handleOpenModaladd} 
							size="large" 
							disableElevation
							disabled={!recommendationList || recommendationList.length > 0}
							startIcon={<ControlPointIcon size="large" />} 
						>
							Add Recommendation
						</Button>
					</div>
				</FilterActionContainer>
				{<DataGrid getRowHeight={() => "auto"} sx={{ m: 2 }} groupBy={"country"} rows={rowsDataGrid} rowClassName="fixed-height-cell" rowHeight={90} columns={columns} pageSize={50} />}
				<AddRecommendationModal isVisible={openModal} onClose={handleCloseModaladd} onSubmit={handleSubmit} existingFormData={existingFormData} labels={labels} country={defaultCountry != null ? defaultCountry : "my"} />
				<Modal className={classes.modal} open={modalOpen} onClose={handleCloseModal}>
					<Box sx={{ width: 300 }}>
						<img src={selectedImageUrl} alt="" style={{ maxHeight: "50%", maxWidth: "100%" }} />
					</Box>
				</Modal>
			</div>
		</ApplicationPageTemplate>
	);
};

export default Recommendation;
